import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationFR from "./fr/translation.json";
import translationEN from "./en/translation.json";
import translationES from "./es/translation.json";
import translationSE from "./se/translation.json";
import translationDE from "./de/translation.json";

i18n.use(initReactI18next).init({
  resources: {
    de: { translation: translationDE },
    en: { translation: translationEN },
    es: { translation: translationES },
    fr: { translation: translationFR },
    se: { translation: translationSE },
  },
  lng: localStorage.getItem("language") || "fr",
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
